import React, {Component} from 'react';

import {Link} from 'react-router-dom';

import taptop from '../assets/images/tap-demo.mov'


export default class TapInstructions extends Component {

    render() {
        return (
            <body>
            <section className="instructions instructions-tap">
                <header className="page-info">
                    <h1 className="page-title">Performance</h1>
                    <p className="narrative">Wow, looks like all those rehearsals paid off and now you’re ready for the big stage! You’ve proven your musical knowledge and skill, now let’s see if you’ve got talent. Break a leg!</p>
                </header>
                <section className="content">
                    <article className="main-content">
                        <h2>Instructions</h2> 
                        <p >Listen to the song’s rhythm. As you see tap steps appear, use your right and left arrow keys to tap along. Or, tap with your fingers if you’re using a mobile device. Each tap step you hit correctly is five points.</p>
                    </article>
                         {/* <aside>
                         <h1 className="try-it">EXAMPLE</h1>
                        <video src={taptop} alt="Tap instructions example video" autoplay="autoplay" id="video"
                        onEnded={() => {
                            setTimeout (() => {document.getElementById('video').play()}, 1500)
                        }}

                        /
                         >
                    </aside> */}
                </section>

                <footer className="page-footer">

                <Link className='button-primary button-exit' to="/songs">Exit </Link>

               <Link className='button-primary' to="/tap">Next</Link>
                </footer>
                </section>
            </body>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/TapInstructions.js